<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros style="width: 500px;"
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <app-filters filtros style="width: 200px;"
    [name]="'filtros.ana' | translate"
    [array]="perspectives"
    [typeFilter]="Filters.PERSPECTIVES"
    [click]="false"
    (eventClick)="cambioPerspectives($event)">
  </app-filters>
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="quitarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="w3-row" style="background-color: white;">
      <div class="w3-row" style="width: 100%; height: 0.5vh;"></div>
      <div class="headers w3-titulo-contenidomenuSC w3-half">
        <span class="w3-margin-left-contenido">{{tituloTabla|translate}}</span>
        <span class="w3-margin-left-contenido">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo">
          @for (per of subTitles; track $index) {
            <span style="margin-left: 5px;">{{escrituraPer(per)}}</span>
          }
        </span>
        @if (multiMoneda) {<span class="w3-margin-left-filter w3-subtitulo">| {{'financiero.catalogoCuentas.moneda'+monedaSelec |translate}}</span>}
      </div>
      <div class="w3-rest w3-right">
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menutabla1">
          more_vert
        </mat-icon>
        <mat-menu #menutabla1="matMenu">
          @if(balanceEstados){
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioBalanceEstados('est')">
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'financiero.catalogoCuentas.tituloTabla2'|translate}}</span>
            </button>
            @if (multiMoneda) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="moneda">
                <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
                <span>{{'filtros.moneda'|translate}}</span>
              </button>
            }
            @if(!analisisVertical && !analisisHorizontal){
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
            @if (analisisVertical) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcelV()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
            @if (analisisHorizontal) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcelH()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
          }@else {
            <button mat-menu-item (click)="cambioBalanceEstados('bal')">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'financiero.catalogoCuentas.tituloTabla1'|translate}}</span>
            </button>
            @if (multiMoneda) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="moneda">
                <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
                <span>{{'filtros.moneda'|translate}}</span>
              </button>
            }
            @if(!analisisVertical && !analisisHorizontal){
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcel2()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
            @if (analisisVertical) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcelV2()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
            @if (analisisHorizontal) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcelH2()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
          }
        </mat-menu>
        <mat-menu #moneda="matMenu">
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': monedaSelec == ''}" 
            [disabled]="monedaSelec == ''" (click)="cambiarMoneda('')">
            <span>{{'filtros.total'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': monedaSelec == 'MN'}" 
            [disabled]="monedaSelec == 'MN'" (click)="cambiarMoneda('MN')">
            <span>{{'filtros.nacional'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': monedaSelec == 'ME'}" 
            [disabled]="monedaSelec == 'ME'" (click)="cambiarMoneda('ME')">
            <span>{{'filtros.extranjera'|translate}}</span>
          </button>
        </mat-menu>
      </div>
      <div class="w3-row" style="width: 100%; height: 1vh;"></div>
    </div>
    <div class="w3-row containerAll w3-scroll">
      @if (balanceEstados) {
        @if(dataOrdenadoBalance.length === 0){
          <app-skeleton-table [columnas]="6" [filas]="13"/>
        }@else {
          <table class="w3-table borderInf ">
            <thead style="background-color: #A7A9AC;">
              @if (analisisHorizontal) {
                <tr class="w3-table-titleBalance">
                  <th class="" style="background-color: #FFFFFF;"></th>
                  <th class="" style="background-color: #FFFFFF;"></th>
                  @for (evaluacion of cadenaEvaluacion; track $index) {
                    <th class="w3-center w3-border-right-balance" style="background-color: #FFFFFF;" ></th>
                  }
                  @for (analisis of cadenaEvaluacionHorizontal; track $index) {
                    <th colspan="2" class="w3-border-right-balance w3-center w3-border-right-balance" style="background-color: #E0E1E3;">
                      <div><span class="w3-table-title2">{{escrituraPer(analisis.evaten)}}</span></div>
                    </th>
                  }
                </tr>
              }
              <tr class="w3-table-titleBalance">
                <th class="w3-elemento-titulo-table marginsH stikyColum w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado1Tabla1'|translate}}</th>
                <th class="w3-elemento-titulo-table marginsH stikyColum w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1'|translate}}</th>
                @for (per of cadenaEvaluacion; track $index) {
                  <th class="w3-elemento-titulo-table  stikyColum w3-border-right-balance"> <span style="margin-left: 5%;">{{escrituraPer(per.evaluacion)}}</span> </th>
                  @if (analisisVertical) {
                    <th class="w3-center w3-elemento-titulo-table stikyColum textColorN1 w3-border-right-balance"><span>{{per.porcentaje}}</span></th>
                  }
                }
                  @if (analisisHorizontal) {
                    @for (analisis of cadenaEvaluacionHorizontal; track $index) {
                      <th class="stikyColum w3-elemento-titulo-table textColorN1" style="text-align: center; background-color: #E0E0E0;">{{'financiero.catalogoCuentas.encabezado3Tabla1'|translate}}</th>
                      <th class="stikyColum w3-elemento-titulo-table textColorN1 w3-border-right-balance" style="text-align: center; background-color: #E0E0E0;">%</th>
                    }
                  }
              </tr>
            </thead>
            <tbody>
              @for (item of dataOrdenadoBalance; track item; let i = $index) {
                @if (item.Check) {
                  <tr [ngClass]="{
                    'w3-table-trtdBalanceBlue w3-encabezado-balance w3-border-Nivel0Balance':item.Nivel===1,
                    'w3-table-trtdBalance w3-cuerpo-balance':item.nivel!==1
                  }" >
                    <td class="borderAllLow" [ngClass]="fontRowBalance(item.idCuenta, item.Nivel)">
                      {{item?.codigo ?? item.idCuenta}}
                    </td>
                    <td class="borderInfLow borderAllLow" [ngClass]="fontRowBalance(item.idCuenta, item.Nivel)">
                      @if (searchSubNivelBalance(item, i)) {
                        <mat-icon (click)="hideShowRowBalance(item, i)" class="iconoMen w3-button">
                          {{item.dbCheck?'expand_less':'expand_more'}}
                        </mat-icon>
                      }@else {
                        <mat-icon class="iconoMen w3-button" style="cursor: default;"></mat-icon>
                      }
                      <span [ngClass]="{
                        'w3-margin-lelf-1roB':item.Nivel===1,
                        'w3-margin-lelf-2doB':item.Nivel===2,
                        'w3-margin-lelf-3roB':item.Nivel===3,
                        'w3-margin-lelf-4toB':item.Nivel===4,
                        'w3-margin-lelf-5toB':item.Nivel===5,
                        'w3-margin-lelf-6toB':item.Nivel===6
                      }">{{item.Descripcion}}</span>
                    </td>
                    @for (dat of item.Series; track dat; let j = $index) {
                      <td class="alinRight borderInfLow borderAllLow" [ngClass]="fontRowBalance(item.idCuenta, item.Nivel)">
                        <span style="margin-right: 5%;">{{dat.valor | formaterNumber:0:miles:decimal}}</span>
                      </td>
                      @if (analisisVertical) {
                        <td class="borderInfLow borderAllLow"[class]="fontDatos(item.Nivel)" [ngClass]="{
                          'textColorN1':item.Nivel===1,
                          'textColorN2':item.Nivel===2,
                          'textColorN3':item.Nivel===3,
                          'textColorN4':item.Nivel>=4}">
                          <div class="w3-row w3-noventa w3-center">
                            <span [class]="fontDatos(item.Nivel,dat.valor)"> {{porcentajeEvaluacionVertical(dataOrdenadoBalance,dat.valor,j,i) | formaterNumber:0:miles:decimal}} %</span>
                          </div>
                        </td>
                      }
                    }
                    @if (analisisHorizontal) {
                      @for (evah of item.evaluacionHorizontal; track $index) {
                        <td class="borderInfLow borderAllLow"  [ngClass]="{
                          'textColorN1':item.Nivel===1,
                          'textColorN2':item.Nivel===2,
                          'textColorN3':item.Nivel===3,
                          'textColorN4':item.Nivel>=4}">
                          <div class="w3-row w3-noventa w3-right-align">
                            <span> {{evah.evaluacionHorizontal | formaterNumber:0:miles:decimal}}</span>
                          </div>
                        </td>
                        <td class="borderInfLow borderAllLow" style="line-height: 1.2; min-width: 5vw;" [ngClass]="{
                          'textColorN1':item.Nivel===1,
                          'textColorN2':item.Nivel===2,
                          'textColorN3':item.Nivel===3,
                          'textColorN4':item.Nivel>=4}">
                          <div class="w3-row w3-noventa w3-right-align">
                            <span> {{evah.porcentajeValorH | formaterNumber:0:miles:decimal}} %</span>
                          </div>
                        </td>
                      }
                    }
                  </tr>
                }
              }
            </tbody>
          </table>
        }        
      }@else {
        <table class="w3-table borderInf">
          <thead style="background-color: #A7A9AC;">
            @if (analisisHorizontal) {
              <tr class="w3-table-titleBalance">
                <th class="" style="background-color: #FFFFFF;"></th>
                <th class="" style="background-color: #FFFFFF;"></th>
                @for (evaluacion of cadenaEvaluacion; track $index) {
                  <th class="w3-center"  style="background-color: #FFFFFF;" ></th>
                }
                @for (analisis of cadenaEvaluacionHorizontal; track $index) {
                  <th colspan="2" class="w3-border-right-balance" style="text-align: center; background-color: #E0E1E3;">
                    <div ><span class="w3-table-title2">{{escrituraPer(analisis.evaten)}} </span></div>
                  </th>
                }
              </tr>
            }
            <tr class="w3-table-titleBalance">
              <th class="w3-elemento-titulo-table marginsH stikyColum w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado1Tabla1'|translate}}</th>
              <th class="w3-elemento-titulo-table marginsH stikyColum w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1'|translate}}</th>
              @for (per of cadenaEvaluacion; track $index) {
                <th class=" w3-elemento-titulo-table stikyColum w3-border-right-balance"><span style="margin-left: 5%;">{{escrituraPer(per.evaluacion)}}</span></th>
                @if (analisisVertical) {
                  <th class="w3-center w3-elemento-titulo-table stikyColum textColorN1 w3-border-right-balance"><span>{{per.porcentaje}}</span></th>
                }
              }
              @if (analisisHorizontal) {
                @for (analisis of cadenaEvaluacionHorizontal; track $index) {
                  <th class="stikyColum w3-elemento-titulo-table textColorN1" style="text-align: center; background-color: #E0E0E0;">{{'financiero.catalogoCuentas.encabezado3Tabla1'|translate}}</th>
                <th class="stikyColum w3-elemento-titulo-table textColorN1 w3-border-right-balance" style="text-align: center; background-color: #E0E0E0;">%</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (item of dataOrdenadoEstados; track item; let i = $index) {
              @if (item.Check) {
                <tr [ngClass]="{
                  'w3-table-trtdBalanceBlue w3-encabezado-balance w3-border-Nivel0Balance':item.Nivel===1,
                  'w3-table-trtdBalance w3-cuerpo-balance':item.Nivel!==1
                }">
                  <td class="borderAllLow" [ngClass]="fontRowEstados(item.idCuenta, item.Nivel)">                    
                    {{item?.codigo ?? item.idCuenta}}
                  </td>
                  <td class="borderAllLow marginsH" [ngClass]="fontRowEstados(item.idCuenta, item.Nivel)">
                    @if (searchSubNivelEstados(item, i)) {
                      <mat-icon (click)="hideShowRowEstados(item, i)" class="iconoMen w3-button">
                        {{item.dbCheck?'expand_less':'expand_more'}}
                      </mat-icon>
                    }@else {
                      <mat-icon class="iconoMen w3-button"></mat-icon>
                    }
                    <span [ngClass]="{
                      'w3-margin-lelf-1roB':item.Nivel===1,
                      'w3-margin-lelf-2doB':item.Nivel===2,
                      'w3-margin-lelf-3roB':item.Nivel===3,
                      'w3-margin-lelf-4toB':item.Nivel===4,
                      'w3-margin-lelf-5toB':item.Nivel===5,
                      'w3-margin-lelf-6toB':item.Nivel===6
                    }">{{item.Descripcion}}</span>
                  </td>
                  @for (dat of item.Series; track dat; let j = $index) {
                    <td class="alinRight borderAllLow" [ngClass]="fontRowEstados(item.idCuenta, item.Nivel)">
                      <span style="margin-right: 5%;">{{dat.valor | formaterNumber:0:miles:decimal}}</span>
                    </td>
                    @if (analisisVertical) {
                      <td class="borderAllLow" [class]="fontDatos(item.Nivel, dat.valor)" [ngClass]="{
                        'textColorN1':item.Nivel===1,
                        'textColorN2':item.Nivel===2,
                        'textColorN3':item.Nivel===3,
                        'textColorN4':item.Nivel>=4}">
                        <div class="w3-row w3-noventa w3-center">
                          <span [class]="fontDatos(item.Nivel,dat.valor)"> {{porcentajeEvaluacionVertical(dataOrdenadoEstados,dat.valor,j, i) | formaterNumber:0:miles:decimal}} %</span>
                        </div>
                      </td>
                    }
                  }
                  @for (evah of item.evaluacionHorizontal; track $index) {
                    @if (analisisHorizontal) {
                      <td class="borderAllLow" [ngClass]="{
                        'textColorN1':item.Nivel===1,
                        'textColorN2':item.Nivel===2,
                        'textColorN3':item.Nivel===3,
                        'textColorN4':item.Nivel>=4}">
                        <div class="w3-row w3-noventa w3-right-align">
                          <span> {{evah.evaluacionHorizontal | formaterNumber:0:miles:decimal}}</span>
                        </div>
                      </td>
                      <td class="borderAllLow" [ngClass]="{
                        'textColorN1':item.Nivel===1,
                        'textColorN2':item.Nivel===2,
                        'textColorN3':item.Nivel===3,
                        'textColorN4':item.Nivel>=4}">
                        <div class="w3-row w3-noventa w3-right-align">
                          <span> {{evah.porcentajeValorH | formaterNumber:0:miles:decimal}} %</span>
                        </div>
                      </td>
                    }
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      }
      <div class="w3-row" style="width: 100%; height: 1vh;"></div>
      <div class="w3-row" style="width: 100%;">
        @if (balanceEstados) {
          <div class="w3-third headersGraf" >
            <div class="w3-row w3-titulo-contenidomenuSC">
              <div class="headers w3-half textoOverFlow" matTooltip="{{titulo1}} &bull; {{escrituraPer(subTitulo1)}}">
                <span class="w3-margin-left-contenido">{{titulo1}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitulo1)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (filtroAct1) {
                  <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                  (click)="borrarFiltros1()" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                    <img src="assets/img/eraser.png">
                  </div>
                }
                <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="showLabels1 = !showLabels1" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ showLabels1 ? 'label_off' : 'label' }}
                </mat-icon> 
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf1')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGraf1">
                  more_vert
                </mat-icon>
                <mat-menu #menuGraf1="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas1">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportIMG(1, titulo1 + ' ' + escrituraPer(subTitulo1))">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #graficas1="matMenu">
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo1 == typeGraph.BAR}" [disabled]="tipo1 == typeGraph.BAR"  (click)="changeGrafic1(typeGraph.BAR)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono4'|translate}}</span>
                  </button>
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo1 == typeGraph.LINE}" [disabled]="tipo1 == typeGraph.LINE" (click)="changeGrafic1(typeGraph.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono5'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo1 == typeGraph.DONUT}" [disabled]="tipo1 == typeGraph.DONUT"  (click)="changeGrafic1(typeGraph.DONUT)">
                    <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono6'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="w3-row" style="width: 100%; height: 2vh;"></div>
            <div class="w3-row zonasGraf3">
              @if(data1.length == 0){
                <app-skeleton-grafica/>  
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels1"
                  [data]="data1"
                  [labels]="etiquetas1"
                  [type]="tipo1"
                  [axisX]="xAxisLabel"
                  [axisY]="yAxisLabel"
                  [zona]="1"
                  [colors]="colorMulti"
                  [formatEtiquetas]="true"
                  [legend]="{enabled: true, position: 'bottom'}"
                  [animations]="true"
                  [altoEtiquetasX]="100"
                  (eventClick)="selectGraf1($event)">                  
                </app-graficador>
              }                
            </div>
          </div>
          <div class="w3-third headersGraf" id="zonaGraf2">
            <div class="w3-row w3-titulo-contenidomenuSC">
              <div class="headers w3-half textoOverFlow"  matTooltip="{{titulo2}} &bull; {{escrituraPer(subTitulo2)}}">
                <span class="w3-margin-left-contenido">{{titulo2}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitulo2)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (filtroAct2) {
                  <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                  (click)="borrarFiltros2()" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                    <img src="assets/img/eraser.png">
                  </div>
                }
                <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="showLabels2 = !showLabels2" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ showLabels2 ? 'label_off' : 'label' }}
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf2')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGraf2">
                  more_vert
                </mat-icon>
                <mat-menu #menuGraf2="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas2">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportIMG(2, titulo2 + ' ' + escrituraPer(subTitulo3))">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #graficas2="matMenu">
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo2 == typeGraph.BAR}" [disabled]="tipo2 == typeGraph.BAR" (click)="changeGrafic2(typeGraph.BAR)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono4'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo2 == typeGraph.LINE}" [disabled]="tipo2 == typeGraph.LINE" (click)="changeGrafic2(typeGraph.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono5'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo2 == typeGraph.DONUT}" [disabled]="tipo2 == typeGraph.BAR" (click)="changeGrafic2(typeGraph.DONUT)">
                    <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono6'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="w3-row" style="width: 100%; height: 2vh;"></div>
            <div class="w3-row zonasGraf3">
              @if(data2.length == 0){
                <app-skeleton-grafica/>  
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels2"
                  [data]="data2"
                  [labels]="etiquetas2"
                  [type]="tipo2"
                  [axisX]="xAxisLabel"
                  [axisY]="yAxisLabel"
                  [zona]="2"
                  [colors]="colorMulti"
                  [formatEtiquetas]="true"
                  [legend]="{enabled: true, position: 'bottom'}"
                  [animations]="true"
                  [altoEtiquetasX]="100"
                  (eventClick)="selectGraf2($event)">                  
                </app-graficador>
              }     
            </div>
          </div>
          <div class="w3-rest headersGraf" id="zonaGraf3">
            <div class="w3-row w3-titulo-contenidomenuSC">
              <div class="headers w3-half textoOverFlow" matTooltip="{{titulo3}} &bull; {{escrituraPer(subTitulo3)}}">
                <span class="w3-margin-left-contenido">{{titulo3}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitulo3)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (filtroAct3) {
                  <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                  (click)="borrarFiltros3()" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                    <img src="assets/img/eraser.png">
                  </div>
                }
                <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="showLabels3 = !showLabels3" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ showLabels3 ? 'label_off' : 'label' }}
                </mat-icon> 
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf3')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGraf3">
                  more_vert
                </mat-icon>
                <mat-menu #menuGraf3="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas3">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportIMG(3, titulo3 + ' ' + escrituraPer(subTitulo3))">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #graficas3="matMenu">
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo3 == typeGraph.BAR}" [disabled]="tipo3 == typeGraph.BAR"  (click)="changeGrafic3(typeGraph.BAR)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono4'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo3 == typeGraph.LINE}" [disabled]="tipo3 == typeGraph.LINE" (click)="changeGrafic3(typeGraph.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono5'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo3 == typeGraph.DONUT}" [disabled]="tipo3 == typeGraph.DONUT" (click)="changeGrafic3(typeGraph.DONUT)">
                    <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono6'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="w3-row" style="width: 100%; height: 2vh;"></div>
            <div class="w3-row zonasGraf3">
              @if(data3.length == 0){
                <app-skeleton-grafica/>  
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels3"
                  [data]="data3"
                  [labels]="etiquetas3"
                  [type]="tipo3"
                  [axisX]="xAxisLabel"
                  [axisY]="yAxisLabel"
                  [zona]="3"
                  [colors]="colorMulti"
                  [formatEtiquetas]="true"
                  [legend]="{enabled: true, position: 'bottom'}"
                  [animations]="true"
                  [altoEtiquetasX]="100"
                  (eventClick)="selectGraf3($event)">                  
                </app-graficador>
              }     
            </div>
          </div>
        }@else {
          <div class="w3-row w3-white" id="zonaGraf4">
            <div class="w3-row w3-titulo-contenidomenuSC">
              <div class="headers w3-half">
                <span class="w3-margin-left-contenido">{{titulo1Res}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitulo1Res)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (filtroAct1Res) {
                  <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                  (click)="borrarFiltrosRes()" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                    <img src="assets/img/eraser.png">
                  </div>
                }
                <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="showLabels4 = !showLabels4" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ showLabels4 ? 'label_off' : 'label' }}
                </mat-icon> 
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf4')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafRes">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafRes="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficasRes">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportIMG(4, titulo1Res + ' ' + escrituraPer(subTitulo1Res))">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #graficasRes="matMenu">
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo4 == typeGraph.BARHORIZONTAL}" [disabled]="tipo4 == typeGraph.BARHORIZONTAL" (click)="changeGraficRes(typeGraph.BARHORIZONTAL)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono4'|translate}}</span>
                  </button>
                  <button mat-menu-item  [ngClass]="{'w3-disabled': tipo4 == typeGraph.LINE}" [disabled]="tipo4 == typeGraph.LINE" (click)="changeGraficRes(typeGraph.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono5'|translate}}</span>
                  </button>
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo4 == typeGraph.DONUT}" [disabled]="tipo4 == typeGraph.DONUT"  (click)="changeGraficRes(typeGraph.DONUT)">
                    <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                    <span>{{'financiero.catalogoCuentas.tooltipIcono6'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="w3-row" style="width: 100%; height: 2vh;"></div>
            <div class="w3-row" style="padding-left: 5%; height: 26vh; width: 95vw;">
              <app-graficador 
                [etiquetas]="showLabels4"
                [data]="data4"
                [labels]="etiquetas4"
                [type]="tipo4"
                [axisX]="xAxisLabel"
                [axisY]="yAxisLabel"
                [zona]="4"
                [colors]="colorMulti"
                [formatEtiquetas]="true"
                [legend]="{enabled: true, position: 'bottom'}"
                [animations]="true"
                [altoEtiquetasX]="100"
                (eventClick)="selectGrafRes($event)">                  
              </app-graficador>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" (close)="modalOpen = false;">
  <div modal-header>
    <div class="w3-row" style="width: 60vw;">
      <!--Titulo-->
      <div class="w3-setenta w3-titulo-contenidomenu padreizquierda">
        <div class="hijoizquierdaTitle" >
          @if (graf1) {
            <span class="w3-margin-left-contenido">{{ titulo1 }}</span>
          }
          @if (graf2) {
            <span class="w3-margin-left-contenido">{{ titulo2 }}</span>
          }
          @if (graf3) {
            <span class="w3-margin-left-contenido">{{ titulo3 }}</span>
          }
          @if (graf4) {
            <span class="w3-margin-left-contenido">{{ titulo1Res }}</span>
          }
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitulo1)}}</span>
        </div>
      </div>
      <div class="w3-rest w3-right" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (filtroAct1 && graf1) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="borrarFiltros1()"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (filtroAct2 && graf2) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="borrarFiltros2()"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (filtroAct3 && graf3) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="borrarFiltros3()"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (filtroAct1Res && graf4) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="borrarFiltrosRes()"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (graf1) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabels1 = !showLabels1" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ showLabels1 ? 'label_off' : 'label' }}
            </mat-icon>
            <!-- Icono exportar -->
            <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
              (click)="exportIMG(1, titulo1 + ' ' + escrituraPer(subTitulo1))" matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          @if (graf2) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabels2 = !showLabels2" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ showLabels2 ? 'label_off' : 'label' }}
            </mat-icon>
            <!-- Icono exportar -->
            <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
              (click)="exportIMG(2, titulo2 + ' ' + escrituraPer(subTitulo2))" matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          @if (graf3) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabels3 = !showLabels3" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ showLabels3 ? 'label_off' : 'label' }}
            </mat-icon>
            <!-- Icono exportar -->
            <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
              (click)="exportIMG(3, titulo3 + ' ' + escrituraPer(subTitulo3))" matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          @if (graf4) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabels4 = !showLabels4" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ showLabels4 ? 'label_off' : 'label' }}
            </mat-icon>
            <!-- Icono exportar -->
            <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
              (click)="exportIMG(4, titulo1Res + ' ' + escrituraPer(subTitulo1Res))" matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%; width: 60vw;">
      @if (graf1) {
        <div class="w3-row contentGraf">
          <app-graficador 
            [etiquetas]="showLabels1"
            [data]="data1"
            [labels]="etiquetas1"
            [type]="tipo1"
            [axisX]="xAxisLabel"
            [axisY]="yAxisLabel"
            [zona]="5"
            [colors]="colorMulti"
            [formatEtiquetas]="true"
            [legend]="{enabled: true, position: 'bottom'}"
            [animations]="true"
            [altoEtiquetasX]="100"
            (eventClick)="selectGraf1($event)">                  
          </app-graficador>
        </div>
      }
      @if (graf2) {
        <div class="w3-row contentGraf">
          <app-graficador 
            [etiquetas]="showLabels2"
            [data]="data2"
            [labels]="etiquetas2"
            [type]="tipo2"
            [axisX]="xAxisLabel"
            [axisY]="yAxisLabel"
            [zona]="6"
            [colors]="colorMulti"
            [formatEtiquetas]="true"
            [legend]="{enabled: true, position: 'bottom'}"
            [animations]="true"
            [altoEtiquetasX]="100"
            (eventClick)="selectGraf2($event)">                  
          </app-graficador>
        </div>
      }
      @if (graf3) {
        <div class="w3-row contentGraf">
          <app-graficador 
            [etiquetas]="showLabels3"
            [data]="data3"
            [labels]="etiquetas3"
            [type]="tipo3"
            [axisX]="xAxisLabel"
            [axisY]="yAxisLabel"
            [zona]="7"
            [colors]="colorMulti"
            [formatEtiquetas]="true"
            [legend]="{enabled: true, position: 'bottom'}"
            [animations]="true"
            [altoEtiquetasX]="100"
            (eventClick)="selectGraf3($event)">                  
          </app-graficador>
        </div>
      }
      @if (graf4) {
        <div class="w3-row contentGraf">
          <app-graficador 
            [etiquetas]="showLabels4"
            [data]="data4"
            [labels]="etiquetas4"
            [type]="tipo4"
            [axisX]="xAxisLabel"
            [axisY]="yAxisLabel"
            [zona]="8"
            [colors]="colorMulti"
            [formatEtiquetas]="true"
            [legend]="{enabled: true, position: 'bottom'}"
            [animations]="true"
            [altoEtiquetasX]="100"
            (eventClick)="selectGrafRes($event)">                  
          </app-graficador>
        </div>
      }
    </div>
  </div>
</app-modal>